import * as React from 'react';

import { translate } from '~l10n/client';
import { atom, useAtom } from 'jotai';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation } from '~shared/components/Dialog';
import { toast } from '~shared/components/Toast';
import { useLogout } from '~teacher/hook/auth/useLogout';

const isOpenAtom = atom(false);

export function LogoutConfirmationDialog() {
  const [isOpen, setIsOpen] = useAtom(isOpenAtom);

  const logoutMutation = useLogout();

  const handleLogout = async () => {
    logoutMutation.mutate(null, {
      onSuccess: () => {
        window.location.href = '/login/teacher/';
      },
      onError: () => {
        toast.critical(
          translate('An unknown error occurred. Please try again later.')
        );
      },
    });
  };

  return (
    <DialogConfirmation
      closeLabel={translate('Close')}
      actions={[
        <UIButton onClick={() => setIsOpen(false)} key="cancel">
          {translate('No')}
        </UIButton>,
        <UIButton appearance="primary" onClick={handleLogout} key="primary">
          {translate('Yes')}
        </UIButton>,
      ]}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      id="sign-out"
      title={translate('Please Confirm')}
    >
      {translate('Are you sure you want to sign out?')}
    </DialogConfirmation>
  );
}

LogoutConfirmationDialog.isOpenAtom = isOpenAtom;
